import React from 'react'

import styled from 'styled-components'

import { screenSize, TabPanelTitle } from 'styles/shared'
import { color } from 'styles/colors'

type Props = {
  className?: string
  headingText: string
  descriptionText?: string
  iconSrc?: string
  canShowNoResultsBanner?: boolean
  noResultsHeadingText?: string
  noResultsDescriptionText?: string
}

const EmptyStatePanel = ({
  className,
  headingText,
  descriptionText,
  iconSrc,
  canShowNoResultsBanner = true,
  noResultsHeadingText,
  noResultsDescriptionText
}: Props) => {
  return (
    <S.Panel className={className}>
      <S.Container>
        {headingText ? <S.TabPanelTitle>{headingText}</S.TabPanelTitle> : null}
        {descriptionText ? (
          <S.Row>
            <S.Icon src={iconSrc || '/img/vector.svg'} alt={headingText} />
            <S.Description>{descriptionText ?? ''}</S.Description>
          </S.Row>
        ) : null}
      </S.Container>
      {canShowNoResultsBanner && (
        <S.NoResultsBannerContainer>
          <S.NoResultsCard>
            {noResultsHeadingText ? (
              <S.NoResultsHeading>{noResultsHeadingText}</S.NoResultsHeading>
            ) : null}
            {noResultsDescriptionText ? (
              <S.NoResultsDescription>
                {noResultsDescriptionText}
              </S.NoResultsDescription>
            ) : null}
          </S.NoResultsCard>
        </S.NoResultsBannerContainer>
      )}
    </S.Panel>
  )
}

export default EmptyStatePanel

const S = {
  Panel: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  `,
  Container: styled.div`
    width: fit-content;
  `,
  TabPanelTitle: styled(TabPanelTitle)`
    font-size: 20px;

    @media ${screenSize.medium} {
      font-size: 16px;
    }
  `,
  Row: styled.div`
    display: flex;
    gap: 8px;
    margin: 0 15px 15px;
    align-items: flex-start;
  `,
  Description: styled.span`
    color: ${color('primaryText')};
    margin: 0;
    font-size: 14px;
    max-width: 535px;

    @media ${screenSize.medium} {
      font-size: 12px;
    }
  `,
  Icon: styled.img`
    width: 16px;
    height: 16px;
    margin-top: 3px;
  `,
  NoResultsBannerContainer: styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 300px;

    @media ${screenSize.medium} {
      min-height: 200px;
    }

    @media ${screenSize.small} {
      min-height: 200px;
    }
  `,
  NoResultsCard: styled.div`
    font-family: Inter, sans-serif;
    text-align: center;
    background-color: ${color('modalGridBackground')};
    padding: 20px 25px;
    border-radius: 16px;
    width: fit-content;
  `,
  NoResultsHeading: styled.h2`
    margin: 10px;
    color: ${color('checkboxText')};
    font-weight: 600;
  `,
  NoResultsDescription: styled.span`
    margin: 10px;
    color: ${color('checkboxText')};
  `
}
